import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=e33a1a6c&scoped=true"
import script from "./ProductForm.vue?vue&type=script&lang=ts"
export * from "./ProductForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e33a1a6c",
  null
  
)

export default component.exports